import { Link } from "react-router-dom";
import { Input } from "reactstrap";
import { H6, Image } from "../../../../../AbstractElements";
import { TopSellingProductsData } from "../../../../../Data/General/Dashboard/Ecommerce";
import { dynamicImage } from "../../../../../Utils";
import { CommonDropdown } from "../../../../CommonComponents/CommonDropdown/CommonDropdown";

const ProductBody = () => {
  return (
    <tbody>
      {TopSellingProductsData.map((item, index) => (
        <tr key={index}>
          <td className="checkbox-checked">
            <div className="form-check">
              <Input type="checkbox" />
            </div>
          </td>
          <td>
            <div className="d-flex">
              <div className="flex-shrink-0">
                <Image src={dynamicImage(item.product_image)} alt="product" />
              </div>
              <div className="flex-grow-1">
                <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product`}>
                  <H6>{item.product_name}</H6>
                  <span>{item.product_id}</span>
                </Link>
              </div>
            </div>
          </td>
          <td>
            <H6>{item.date}</H6>
            <span>{item.time}</span>
          </td>
          <td>{item.customer}</td>
          <td>{item.price}</td>
          <td className={`txt-${item.color}`}>{item.status}</td>
          <td><CommonDropdown days dropdownClass="dropdown-toggle" /></td>
        </tr>
      ))}
    </tbody>
  );
};

export default ProductBody;
